export const UNKNOWN = 'UNKNOWN' as const;
export type Unknown = typeof UNKNOWN;

export const ARCHETYPES = ['ROTATING', 'VESSEL', 'FIXED', 'MEMBRANE', 'DOSING', 'VALVE', 'DEVICE'] as const;
export type Archetype = (typeof ARCHETYPES)[number];

export const TIERS = ['A', 'B', 'C'] as const;
export type Tier = (typeof TIERS)[number];

export const PROGRAMMES = [
  'CLEANING',
  'MECHANICAL_PM',
  'INSPECTION',
  'DESLUDGING',
  'REFILL',
  'PUMP_PM',
  'BACKWASH',
  'MEDIA_INSPECTION',
  'CIP',
  'LAMP_REPLACEMENT',
  'CARTRIDGE_REPLACEMENT',
  'CLOTH_REPLACEMENT',
  'TONNER_CHANGE',
] as const;
export type Programme = (typeof PROGRAMMES)[number];

export const READING_KINDS = ['STATUS', 'PROCESS', 'ANALYTICAL', 'METER', 'COMPUTED'] as const;
export type ReadingKind = (typeof READING_KINDS)[number];

export const READING_PLACES = ['equipment', 'connection'] as const;
export type ReadingPlace = (typeof READING_PLACES)[number];

export const DIRECTIONS = ['ABOVE', 'BELOW'] as const;
export type Direction = (typeof DIRECTIONS)[number];

export const WORK_TYPES = ['ROUTINE', 'PM', 'CALIBRATION'] as const;
export type WorkType = (typeof WORK_TYPES)[number];

export const DUE_BASES = ['CALENDAR', 'METER', 'EITHER'] as const;
export type DueBasis = (typeof DUE_BASES)[number];

export const CADENCE_UNITS = ['DAY', 'WEEK', 'MONTH', 'YEAR'] as const;
export type CadenceUnit = (typeof CADENCE_UNITS)[number];

export const PERFORMED_BY = ['IN_HOUSE', 'VENDOR', 'AUTO'] as const;
export type PerformedBy = (typeof PERFORMED_BY)[number];

export const PLANT_TYPES = ['STP', 'ETP', 'WTP'] as const;
export type PlantTypeCode = (typeof PLANT_TYPES)[number];

export const FORM_RULE_READS = ['EXPECTS', 'LIMITS', 'SCHEDULE', 'FLAG', 'DERIVED'] as const;
export type FormRuleReads = (typeof FORM_RULE_READS)[number];

export const FORM_DERIVATIONS = ['VOLUME', 'NUMBER', 'FULL_LOAD_AMPS'] as const;
export type FormDerivation = (typeof FORM_DERIVATIONS)[number];

export const FORM_MATCHES = ['ANSWERED', 'ON', 'EQUALS', 'MATCHES'] as const;
export type FormMatch = (typeof FORM_MATCHES)[number];

export const ITEM_KINDS = ['ALERT', 'SCHEDULE', 'CONDITION_JOB'] as const;
export type ItemKind = (typeof ITEM_KINDS)[number];

export const SEVERITIES = ['CAUTION', 'MINOR', 'MAJOR', 'EMERGENCY'] as const;
export type Severity = (typeof SEVERITIES)[number];

export const SEVERITY_RANK: Readonly<Record<Severity, number>> = { CAUTION: 0, MINOR: 1, MAJOR: 2, EMERGENCY: 3 };

export const STORED_SOURCES = ['explicit', 'shape-default'] as const;
export type StoredSource = (typeof STORED_SOURCES)[number];

export const VERSION_ACTIONS = ['CREATE', 'UPDATE', 'ARCHIVE', 'RESTORE'] as const;
export type VersionAction = (typeof VERSION_ACTIONS)[number];

export const WARNING_CODES = [
  'NOT_IN_DATABASE',
  'UNKNOWN_READING',
  'DUPLICATE_TAG',
  'DUPLICATE_EQUIPMENT',
  'EQUIPMENT_MISSING',
  'SENSOR_WITHOUT_EQUIPMENT',
  'WIDGET_BINDING_MISMATCH',
  'UNKNOWN_LINK_TYPE',
  'GATE_DROPPED',
  'NESTED_BOUNDARY_UNRESOLVED',
  'SHAPE_DEFAULT_STORED',
] as const;
export type WarningCode = (typeof WARNING_CODES)[number];

export const APPLY_OUTCOMES = ['created', 'updated', 'unchanged', 'archived', 'failed'] as const;
export type ApplyOutcome = (typeof APPLY_OUTCOMES)[number];

export const READING_SOURCES = ['tag-map', 'sensor-purpose', 'widget-kind', 'unknown'] as const;
export type ReadingSource = (typeof READING_SOURCES)[number];

export const READING_ATTRIBUTIONS = ['link', 'sensor-equipment', 'both'] as const;
export type ReadingAttribution = (typeof READING_ATTRIBUTIONS)[number];

export const REFUSAL_CODES = [
  'REASON_TOO_SHORT',
  'REASON_TOO_LONG',
  'CODE_IMMUTABLE',
  'NOT_FOUND',
  'NO_LAYOUT',
  'VERSION_CONFLICT',
  'ALREADY_EXISTS',
  'IN_USE',
  'NOT_IN_DATABASE',
  'LIBRARY_ARCHIVED',
  'NOT_EQUIPMENT',
  'UNKNOWN_NODE_TYPE',
  'LIBRARY_RULES',
  'REGISTRY_RULES',
  'UNKNOWN_ITEM',
] as const;
export type RefusalCode = (typeof REFUSAL_CODES)[number];

export const CONTENT_FIELDS = [
  'name',
  'archetype',
  'holdsWater',
  'tier',
  'expects',
  'tagPrefix',
  'readings',
  'tagMap',
  'alerts',
  'schedules',
  'conditionJobs',
  'formRules',
  'nextPhase',
  'cycles',
  'confirm',
] as const;
export type ContentField = (typeof CONTENT_FIELDS)[number];

export const SERVER_FIELDS = ['_id', '__v', 'code', 'version', 'seededFrom', 'isArchived', 'createdBy', 'updatedBy', 'createdAt', 'updatedAt'] as const;

export const REASON_LIMITS = {
  change: { min: 10, max: 500 },
} as const;

export const MAINTENANCE_LIMITS = { minHours: 0, maxHours: 8760, noteMax: 1000, defaultHours: 4 } as const;

export const NO_LAYOUT_CODE: RefusalCode = 'NO_LAYOUT';
